import React, { useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { getParticipates } from '../../slices/participateSlice';
import ParticipatesComp from '../../components/participates';
import LoaderCP from '../../components/loader';

const ParticipatesSection = () => {
  const dispatch = useDispatch();
  const { participates, status } = useSelector((state) => state.participates);

  useEffect(() => {
    dispatch(getParticipates());
  }, []);

  return (
    <div>
      {status === 'loading' ? <LoaderCP /> : ''}
      {participates.length > 0
        ? <ParticipatesComp items={participates} />
        : '' }
    </div>
  );
};

export default ParticipatesSection;
